import api from './axios';
import { LoginRequest, RegisterRequest, AuthResponse, RegisterAcceptedResponse, User } from '../types/auth.types';

export const authApi = {
  register: async (data: RegisterRequest): Promise<RegisterAcceptedResponse> => {
    const response = await api.post<RegisterAcceptedResponse>('/auth/register', data);
    return response.data;
  },

  login: async (data: LoginRequest): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/auth/login', data);
    return response.data;
  },

  getCurrentUser: async (): Promise<User> => {
    const response = await api.get<User>('/auth/me');
    return response.data;
  },
};
